import { skipToken, useQuery } from '@tanstack/react-query';

import useInvoices from '~hooks/useInvoices/useInvoices';

export const jobInvoicesQueryKey = (companyId: string, jobId: string) =>
  ['jobInvoices', companyId, jobId] as const;

export default function useJobInvoicesQuery(companyId: string, jobId: string) {
  const { getJobPayable, getJobReceivable } = useInvoices();

  const { data, isLoading } = useQuery({
    queryKey: jobInvoicesQueryKey(companyId, jobId),
    queryFn:
      companyId && jobId
        ? async ({ signal }) => {
            const [payable, receivable] = await Promise.all([
              getJobPayable(jobId, companyId, { signal }),
              getJobReceivable(jobId, companyId, { signal }),
            ]);

            return { payable: payable ?? null, receivable: receivable ?? null };
          }
        : skipToken,
  });

  return {
    isLoading,
    payable: data?.payable ?? null,
    receivable: data?.receivable ?? null,
  };
}
